import React from 'react'
import PermisosUsuarios from '../components/PermisosUsuarios'

const usuarios = () => {
  return (
    <PermisosUsuarios />
  )
}

export default usuarios